import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NzFormModule} from 'ng-zorro-antd/form';
import {GnFormItemComponent} from './form-item/form-item.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GnFormDirective} from './form.directive';


@NgModule({
  declarations: [GnFormDirective, GnFormItemComponent],
  exports: [
    GnFormDirective,
    GnFormItemComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule
  ]
})
export class GnFormModule {
}
